import {
	ContextMenu,
	ContextMenuDeleteItem,
	ContextMenuItem,
	ContextMenuLinkItem,
	isSuccess,
	useToasts,
} from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { applicationService } from "../shared/api/applicationService";
import { eventService } from "../shared/api/event/eventService";
import { ApplicationIndexResource } from "../shared/types";

interface Props {
	application: ApplicationIndexResource;
	handleEdit: () => void;
}

export const ApplicationContextMenu: FC<Props> = ({ application, handleEdit }) => {
	const { t } = useTranslation();
	const queryClient = useQueryClient();
	const { showToast } = useToasts();

	const handleDelete = async () => {
		const response = await applicationService.destroy(application.id);

		if (isSuccess(response)) {
			showToast({
				type: "success",
				title: t("Delete application"),
				body: t("Application was successfully deleted."),
			});
			void queryClient.invalidateQueries({ queryKey: applicationService.keys.list });
			void queryClient.invalidateQueries({ queryKey: eventService.indexKey });
		}
	};

	return (
		<>
			<ContextMenu>
				<ContextMenuDeleteItem
					action={handleDelete}
					label={t("Delete application")}
					title={t("Delete application")}
					heading={t("Delete application")}
					labels={{ close: t("Close"), confirm: t("Confirm") }}
				>
					{t("Are you sure you want to delete this application?")}
				</ContextMenuDeleteItem>
				<ContextMenuItem action={handleEdit} label={t("Edit application")} title={t("Edit application")} icon="edit" />
				<ContextMenuLinkItem
					to={`../${application.id}/users`}
					label={t("Edit application users")}
					title={t("Edit application users")}
					icon="people"
				/>
			</ContextMenu>
		</>
	);
};
